import { Layout } from "antd";
import Sidebar from "./Sidebar";
import { useIdleTimer } from "../hooks/useIdleTimer";
import { useDispatch } from "react-redux";
import { performLogout } from "../utils/performLogout";

const GeneralLayout = ({ children }) => {
  const dispatch = useDispatch();

  // Hard-navigate on idle logout (performLogout) so the re-login lands on the
  // latest bundle instead of this tab's stale one.
  const handleIdle = () => {
    performLogout(dispatch);
  };

  // Log the user out after an hour idle (3600000 ms)
  useIdleTimer(handleIdle, 3600000);
  return (
    <Layout
      className="flex font-[Inter] bg-[white]"
      style={{
        fontFamily: "Inter, sans-serif",
        backgroundColor: "white",
        // height: "100vh",
      }}
    >
      <Sidebar />
      {children}
    </Layout>
  );
};

export default GeneralLayout;
